// v=54999174947226377801791449962
theme.library = 2425952412480648616;
theme.crr_library = localStorage.getItem('library') || '[]';
theme.strings = {
  inStock: "Em stock",
  outOfStock: "Indisponível",
  soldOut: "Indisponível",
  addToCart: "Adicionar ao carrinho",
  addedToCart: "Tem no carrinho",
  contact: "Contacte",
  remove: "Remover",
  empty: "O seu carrinho está vazio",
  cartItem: "Tem \u003cspan class='text-bold'\u003e(1 item)\u003c\/span\u003e no seu carrinho",
  cartItems: "Tem \u003cspan class='text-bold'\u003e(2 itens)\u003c\/span\u003e no seu carrinho",
  titleTotal: "Subtotal",
  noimage: "\/\/loja.incm.pt\/cdn\/shop\/t\/16\/assets\/noimage.gif?v=48054",
  infoButton: "Info",
  customButton: "Personalizado",
  cdday: "Dias",
  cdhrs: "Horas",
  cdmin: "Minutos",
  cdsecs: "Segundos",
  no_shopping: "Não existem métodos de envio disponíveis para o seu carrinho ou endereço",
  nll_send: "A enviar...",
  nll_error_mesenger: "Não foi possível ligar ao servidor de registro. Por favor, tente novamente mais tarde.",
  nll_success_mesenger: "OBRIGADO PELA SUBSCRIÇÃO!\u003c\/br\u003eUse o \u003cspan class=\"code\"\u003e\u003c\/span\u003e código para obter um desconto na sua primeira compra.",
  aspect_ratio: "270/350",
  search_dropdown_pages: "Páginas",
  search_dropdown_articles: "Acerca de",
  search_dropdown_no_results: "A sua pesquisa não produziu nenhum resultado."
};
theme.productStrings = {
  sizeGuide: "Guia de Tamanho",
  addToCart: "Adicionar ao carrinho",
  preOrder: "Reservar",
  selectOption: "Selecione as opções",
  soldOut: "Indisponível",
  inStock: "Em stock",
  outOfStock: "Indisponível",
  unavailable: "Indisponível",
  onlyLeft: 'Apenas <span>1</span> restam',
  onSale: 'Promoção',
  stockMessage: ["Hurry! Only "," left in stock."],
  label_select: "Selecionar a",
  viewMoreVariants: "Mais",
  addToWishlist: "Adicionar à lista de desejos",
  viewWishlist: "Ver a minha lista de desejos"
};
theme.function = {
  multiCurrency: false,
  autoCurrency: true,
  searchAjax: false,
  searchByCollection: true,
  searchAjaxTypes: "product",
  vrsgallery: true,
  quickshop: "true",
  quickview: false,
  fquickview: "false",
  use_am_popup: false,
  productImgType: "normal",
  productOptionStyle: [{'name': "Color",'style': "combobox",'color_watched': false,'op_attach': false,'op_pre_select': true},{'name': "Size",'style': "not_select square",'color_watched': false,'op_attach': false,'op_pre_select': false},{'name': "Style",'style': "combobox with_out_variant_image",'color_watched': false,'op_attach': false,'op_pre_select': false},{'name': "",'style': "combobox",'color_watched': false,'op_attach': false,'op_pre_select': false},{'name': "",'style': "combobox",'color_watched': false,'op_attach': false,'op_pre_select': false}],
  productGridOptionStyle: [{'name': "Color",'style': "square _big",'color_watched': false, 'sw_style': "image_variant"},{'name': "Size",'style': "list list_1",'color_watched': false, 'sw_style': "image_variant"},{'name': "Material",'style': "list list_1",'color_watched': false, 'sw_style': "image_variant"},{'name': "",'style': "list list_1",'color_watched': false, 'sw_style': "image_variant"},{'name': "",'style': "list list_1",'color_watched': false, 'sw_style': "image_variant"}],
  photoZoom: true,
  nll_ajax: true,
  ajax_cart: "drop",
  cart_shipping_calculator: false,
  navText: ['<i class="fkt-angle-left fkt-2x fkt-va"></i>','<i class="fkt-angle-right fkt-2x fkt-va"></i>'],
  textInListShipping: "em pedido sobre",
  product_delivery: {
    offSaturday: true,
    offSunday: true,
    offDays: ["23\/12\/****","24\/12\/****","01\/01\/****","02\/11\/2019"],
    fromDate: 10,
    toDate: 19 
  }
};
theme.compare = {
  remove: "Remover"
};
theme.gadget = {
  cookies_infor: false,
  newsletter_popup: false,
  shipTo: true
};

theme.suggest = {
  enable: false,
  collection_opj: "destaques",
  delay_time: 15000,
  show_time: 7600,
  use_fake_location: false,
  arr_fake_location: ["Melbourne, Australia","Washington","Nevada"]
};
theme.extensions = {
  ktToolsCss: '//loja.incm.pt/cdn/shop/t/16/assets/ktTools.scss.css?v=22945105168615461471791449962',
  ktToolsJs: '//loja.incm.pt/cdn/shop/t/16/assets/ktTools.js?v=23518685763435140231791449962',
  ktToolsSlideshowJs: '//loja.incm.pt/cdn/shop/t/16/assets/ktTools.slideshow.js?v=103210400404883977421791449978',
  adminThemeTool: '//loja.incm.pt/cdn/shop/t/16/assets/adminThemeTool.scss.css?v=26032429354608457171791449962',
  ktToolsSettingsPreset: '//loja.incm.pt/cdn/shop/t/16/assets/settings_preset.js?v=48054'
}

const firstLink = document.getElementsByTagName("link")[0];
const headDocument = document.head;
const bodyDocument = document.body;
var $ = $jqMolla;

if (theme.crr_library.length == 0) {
  localStorage.setItem('library','[]');
}

window._handleize = function(str){
  str = str.toLowerCase().replace(/'|"|\(|\)|\[|\]/g, "").replace(/\W+/g, "-")
  return str.replace(/^-+|-+$/g, "")
}
window._snakeCase = function(str){
  str = str.toLowerCase().replace(/'|"|\(|\)|\[|\]/g, "").replace(/\W+/g, "_")
  return str.replace(/^-+|-+$/g, "")
}

"undefined" == typeof KT && (KT = {});
KT.checkVersion = function(name_item){
  name_item = name_item.split('/')[name_item.split('/').length - 1];
  var version = false;
  if(!localStorage.getItem(name_item)){
    version = true; 
  }
  var libs_ver = JSON.parse(theme.crr_library);
  if (libs_ver.length && libs_ver.findIndex(function(obj){ return obj.name == name_item}) !== -1) { 
    var objIndex = libs_ver.findIndex(function(obj){ return obj.name == name_item});
    if (parseFloat(libs_ver[objIndex].ver) !== theme.library) {
      libs_ver[objIndex].ver = theme.library;
      localStorage.setItem('library',JSON.stringify(libs_ver));
      version = true;
    }
  } else if(libs_ver.findIndex(function(obj){ return obj.name == name_item}) === -1){
    version = true;
  }
  return version; 
}
KT.pushVersion = function(name_item){
  var libs_ver = JSON.parse(theme.crr_library);
  if (libs_ver.length && libs_ver.findIndex(function(obj){ return obj.name == name_item}) !== -1) { 
    var objIndex = libs_ver.findIndex(function(obj){ return obj.name == name_item});
    if (parseFloat(libs_ver[objIndex].ver) !== theme.library) {
      libs_ver[objIndex].ver = theme.library;
      localStorage.setItem('library',JSON.stringify(libs_ver));
    }
  }
  else {
    var obj = {
      name : name_item,
      ver : theme.library
    }
    libs_ver.push(obj);
    localStorage.setItem('library',JSON.stringify(libs_ver));
  }
  theme.crr_library = localStorage.getItem('library') || '[]';
}
KT.loadScript = function(id, callback) {
  let css_url = "";
  let js_url = "";
  let done = false;
  // var file_name_css = '';
  if($('#'+id).length){
    checkExists(id, js_url)
  }
  else {
    if(id == 'magnific-popup' && $('#magnific-popup-css').length <= 0){
      css_url = "//loja.incm.pt/cdn/shop/t/16/assets/magnific-popup.min.css?v=57525974320827922071791449962";
      js_url = "//loja.incm.pt/cdn/shop/t/16/assets/jquery.magnific-popup.min.js?v=184369421263510081681791449962";
    }
    else if(id == 'threesixty' && $('#threesixty-css').length <= 0){
      css_url = "//loja.incm.pt/cdn/shop/t/16/assets/threesixty.min.css?v=110917158222743342331791449962";
      js_url = "//loja.incm.pt/cdn/shop/t/16/assets/threesixty.min.js?v=82311723604142068331791449962";
    }
    else if(id == 'photo-swipe' && $('#photo-swipe-css').length <= 0){
      css_url = "//loja.incm.pt/cdn/shop/t/16/assets/photoswipe-ui.min.css?v=50182594455179234001791449962";
      js_url = "//loja.incm.pt/cdn/shop/t/16/assets/photoswipe-ui.min.js?v=89145670203526742621791449962";
    }
    else if(id == 'YTPlayer'){
      css_url = "//loja.incm.pt/cdn/shop/t/16/assets/jquery.mb.YTPlayer.min.css?v=59914316629707384691791449962";
      js_url = "//loja.incm.pt/cdn/shop/t/16/assets/jquery.mb.YTPlayer.min.js?v=127366606670431650381791449962";
    }
    else if(id == 'swiper'){
      js_url = "//loja.incm.pt/cdn/shop/t/16/assets/swiper.min.js?v=169146728960025539401791449962";
    }
    else if(id == 'owl-carousel'){
      js_url = "//loja.incm.pt/cdn/shop/t/16/assets/owl.carousel.min.js?v=97891440811553454251791449962";
    }
    else if(id == 'pjax'){
      js_url = "//loja.incm.pt/cdn/shop/t/16/assets/jquery.pjax.min.js?v=96510263879411166301791449962";
    }
    else if(id == 'imagesloaded'){
      js_url = "//loja.incm.pt/cdn/shop/t/16/assets/imagesloaded.pkgd.min.js?v=48054";
    }
    else if(id == 'isotope'){
      js_url = "//loja.incm.pt/cdn/shop/t/16/assets/isotope-plus.pkgd.min.js?v=139088845446234680461791449962";
    }
    else if(id == 'instafeed'){
      js_url = "//loja.incm.pt/cdn/shop/t/16/assets/instafeed.min.js?v=90032470946696484961791449962";
    }
    else if(id == 'countdown'){
      js_url = "//loja.incm.pt/cdn/shop/t/16/assets/jquery.countdown.min.js?v=44111188705250456101791449962";
    }
    else if(id == 'countto'){
      js_url = "//loja.incm.pt/cdn/shop/t/16/assets/jquery.countTo.min.js?v=148382760188409556611791449962";
    }
    else if(id == 'moment'){
      js_url = "//loja.incm.pt/cdn/shop/t/16/assets/moment.min.js?v=96302747854271246571791449962";
    }
    else if(id == 'momentlocale'){
      if (shopLocale === 'en') {handleLoad(); return}
      js_url = "//cdnjs.cloudflare.com/ajax/libs/moment.js/2.24.0/locale/"+shopLocale+".js";
    }
    else if(id == 'zoom'){
      js_url = "//loja.incm.pt/cdn/shop/t/16/assets/jquery.zoom.min.js?v=43605473953727732241791449962";
    }
    else if(id == 'tippy'){
      js_url = "//loja.incm.pt/cdn/shop/t/16/assets/tippy-bundle.iife.min.js?v=119878756178377760041791449962";
    }
    else if(id == 'color_sw'){
      css_url = "//loja.incm.pt/cdn/shop/t/16/assets/swatch-color.css?v=138168965868534421781791449962";
    }
    else if(id == 'animate'){
      css_url = "//loja.incm.pt/cdn/shop/t/16/assets/animate.min.css?v=20349278028107590831791449962";
    }
    else if(id == 'adminThemeCss'){
      css_url = "//loja.incm.pt/cdn/shop/t/16/assets/adminThemeTool.scss.css?v=26032429354608457171791449962";
    }
    done = false;
    ajaxLoad(id, css_url, js_url);
  }
  function ajaxLoad(name, css_url, js_url){
    if(css_url !== ''){
      var scr_css = document.createElement('link');
      scr_css.type = 'text/css';
      scr_css.rel = "stylesheet";
      scr_css.id = name+'-css';
      scr_css.href = css_url;
      scr_css.onerror = function() {
        alert("Error loading css " + this.href);
      };
      headDocument.insertBefore(scr_css, firstLink);
    }
    if(js_url !== ''){
      var scr_js = document.createElement('script');
      scr_js.type = 'text/javascript';
      scr_js.async = true;
      scr_js.src = js_url;
      scr_js.id = name;
      scr_js.onload = checkExists(name, js_url);
      scr_js.onerror = function() {
        alert("Error loading js " + this.src);
      };
      bodyDocument.appendChild(scr_js);
    }
  }
  function checkExists(id, js_url){
    var callbackTimer = setInterval(function() {
      if (id == 'swiper' && typeof Swiper === 'function'){
        handleLoad()
        clearInterval(callbackTimer);
        return true;
      }
      if (id == 'owl-carousel' && typeof $.fn.owlCarousel === 'function'){
        handleLoad()
        clearInterval(callbackTimer);
        return true;
      }
      if (id == 'slick-slide' && typeof $.fn.slick === 'function'){
        handleLoad()
        clearInterval(callbackTimer);
        return true;
      }
      if (id == 'moment' && typeof moment === 'function'){
        handleLoad()
        clearInterval(callbackTimer);
        return true;
      }
      if (id == 'magnific-popup' && typeof $.fn.magnificPopup === 'function'){
        handleLoad()
        clearInterval(callbackTimer);
        return true;
      }
      if (id == 'imagesloaded' && typeof $.fn.imagesLoaded === 'function'){
        handleLoad()
        clearInterval(callbackTimer);
        return true;
      }
      if (id == 'isotope' && typeof $.fn.isotope === 'function'){
        handleLoad()
        clearInterval(callbackTimer);
        return true;
      }
      if (id == 'YTPlayer' && typeof jQuery.fn.YTPlayer === 'function'){
        handleLoad()
        clearInterval(callbackTimer);
        return true;
      }
      if (id == 'parallax' && typeof $.fn.mouseMove === 'function'){
        handleLoad()
        clearInterval(callbackTimer);
        return true;
      }
      if (id == 'countdown' && typeof $.fn.countdown === 'function'){
        handleLoad()
        clearInterval(callbackTimer);
        return true;
      }
      if (id == 'countto' && typeof $.fn.countTo === 'function'){
        handleLoad()
        clearInterval(callbackTimer);
        return true;
      }
      if (id == 'magnific-popup' && typeof $.fn.magnificPopup == 'function'){
        handleLoad()
        clearInterval(callbackTimer);
        return true;
      }
      if (id == 'instafeed' && typeof Instafeed == 'function'){
        handleLoad()
        clearInterval(callbackTimer);
        return true;
      }
      if (id == 'momentlocale' && moment.locale() == shopLocale){
        handleLoad()
        clearInterval(callbackTimer);
        return true;
      }
      if (id == 'zoom' && typeof $.fn.zoom == 'function'){
        handleLoad()
        clearInterval(callbackTimer);
        return true;
      }
      if(id === 'pjax' && typeof $.fn.pjax == 'function') {
        handleLoad()
        clearInterval(callbackTimer);
        return true;
      }
      if(id === 'photo-swipe' && typeof PhotoSwipe == 'function') {
        handleLoad()
        clearInterval(callbackTimer);
        return true;
      }
      if(id === 'threesixty' && typeof $jq == 'function' && typeof $jq.fn.ThreeSixty == 'function') {
        handleLoad()
        clearInterval(callbackTimer);
        return true;
      }
      if(id === 'tippy' && typeof tippy == 'function') {
        handleLoad()
        clearInterval(callbackTimer);
        return true;
      }
    }, 100);
  }
  function handleLoad() {
    if (!done) {
      done = true;
      // console.log(js_url)
      callback(js_url, "ok");
    }
  }
}